/* eslint-disable react/jsx-no-target-blank */
export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-menu">
        <a href="https://www.unsw.edu.au/about-us/" target="_blank">
          About UNSW
        </a>
        <a href="https://www.unsw.edu.au/privacy" target="_blank">
          Privacy Policy
        </a>
        <a href="https://www.unsw.edu.au/copyright-disclaimer" target="_blank">
          Copyright and Disclaimer
        </a>
        <a
          href="https://www.unsw.edu.au/about-us/our-story/contact-us"
          target="_blank"
        >
          Contact Us
        </a>
      </div>
      {/*<div className="footer-copyright">*/}
      {/*  <p>@ 2024 Mentem by UNSW. All rights reserved.</p>*/}
      {/*</div>*/}
    </div>
  )
}
